<div style="position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px">
  <app-loading-spinner *ngIf="showLoading | async"></app-loading-spinner>
  <app-splash-screen></app-splash-screen>
  <router-outlet>
  </router-outlet>
</div>
